/**
 * Neon Radial Progress Indicator
 * Animates SVG circle progress on scroll using GSAP + ScrollTrigger
 */

export function initRadialProgress() {
  const selector = '[data-radial-progress]';
  const attrPercent = 'data-percent';
  const attrColor = 'data-color';
  const defaultColor = '#ff7f3e';
  const defaultPercent = 50;

  document.querySelectorAll(selector).forEach((container) => {
    // Read attributes
    const targetPercent = parseFloat(container.getAttribute(attrPercent)) || defaultPercent;
    const color = container.getAttribute(attrColor) || defaultColor;

    // Find elements
    const progressCircle = container.querySelector('[data-progress-circle]');
    const outlineCircle = container.querySelector('[data-outline-circle]');
    const innerOutlineCircle = container.querySelector('[data-inner-outline-circle]');
    const percentText = container.querySelector('[data-percent-text]');

    if (!progressCircle || !percentText) {
      console.warn('Radial progress: missing required elements', container);
      return;
    }

    // Apply color to progress circle
    progressCircle.style.stroke = color;
    progressCircle.style.filter = `drop-shadow(0 0 8px ${color})`;

    // Apply color to outline circle if it exists
    if (outlineCircle) {
      outlineCircle.style.stroke = color;
    }

    // Apply color to inner outline circle if it exists
    if (innerOutlineCircle) {
      innerOutlineCircle.style.stroke = color;
    }

    // Calculate circle properties
    const radius = progressCircle.r.baseVal.value;
    const circumference = 2 * Math.PI * radius;

    // Set up stroke-dasharray and initial offset (0% progress)
    progressCircle.style.strokeDasharray = `${circumference}`;
    progressCircle.style.strokeDashoffset = `${circumference}`;

    // Initial text
    percentText.textContent = '0%';

    // Create animation timeline
    const tl = gsap.timeline({
      paused: true,
      onUpdate: function () {
        // Update percentage text during animation
        const progress = this.progress();
        const currentPercent = Math.round(progress * targetPercent);
        percentText.textContent = `${currentPercent}%`;
      }
    });

    // Animate stroke offset from full (hidden) to target percentage
    const targetOffset = circumference - (targetPercent / 100) * circumference;
    
    tl.to(progressCircle, {
      strokeDashoffset: targetOffset,
      duration: 1.2,
      ease: 'power2.out'
    }, 0);

    // Create ScrollTrigger
    ScrollTrigger.create({
      trigger: container,
      start: 'top 80%',
      once: true, // Trigger only once (set to false for replay)
      onEnter: () => {
        tl.play();
      }
    });

    // Store references for potential future control
    container._radialProgressTimeline = tl;
  });
}
